import { render, staticRenderFns } from "./labs.vue?vue&type=template&id=4ea9d322&scoped=true&"
import script from "./labs.vue?vue&type=script&lang=js&"
export * from "./labs.vue?vue&type=script&lang=js&"
import style0 from "./labs.vue?vue&type=style&index=0&id=4ea9d322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9d322",
  null
  
)

export default component.exports